import { render, staticRenderFns } from "./comp-admin-route.vue?vue&type=template&id=42457cec&"
import script from "./comp-admin-route.vue?vue&type=script&lang=ts&"
export * from "./comp-admin-route.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports